import { WIND } from '../../constants/sites.constant';

export class NavigationHelper {
  static navigationDefault = {
    level: 'portfolio',
    module: 'monitor/',
    selectedPortfolio: {
      name: 'Main Portfolio',
      _id: '',
      sites: [],
    },
    selectedSite: {
      id: '',
      name: '',
      timezone: '',
      timezone_offset: '',
      status: 0,
      site_type: WIND,
    },
  };
}
